import React from 'react';
import PropTypes from 'prop-types';
import { Link as ReactRouterLink } from 'react-router-dom';
import styled from '@emotion/styled';

const propTypes = {
  children: PropTypes.node.isRequired,
  href: PropTypes.string.isRequired,
};

const UnstyledLink = styled(ReactRouterLink)`
  color: ${props => props.theme.color};
  font-size: ${props => props.theme.fontSize_base};
  text-decoration: none;
  &:focus {
    color: ${props => props.theme.color_theme_focus};
    outline: 1px solid ${props => props.theme.borderColor_theme_focus};
    outline-offset: 2px;
  }
  &:hover {
    color: ${props => props.theme.color_theme_hover};
  }
`;

// Wrapper to provide consisted interface
// Also, users do not need to be careful when passing props.
// ReactRouterLink passes along all extra props to the anchor tag
// By wrapping we can prevent component users from doing so accidentally
export default function UnstyledLinkWrapper({ children, href }) {
  return (
    <UnstyledLink to={href}>
      {children}
    </UnstyledLink>
  );
}

UnstyledLinkWrapper.propTypes = propTypes;
